import React, { useState } from 'react';
import Box from '@mui/material/Box';
import orderHelpers from '../../helpers/orders';
import WalmartPalletAllocationForm from './WalmartPalletAllocationForm';
import WalmartPalletAllocationSummaryTable from './WalmartPalletAllocationSummaryTable';
import WalmartPalletAllocationTable from './WalmartPalletAllocationTable';
import Button from '@mui/material/Button';

function WalmartPalletAllocation(props) {

    const [orderSummary, setOrderSummary] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    const [palletAssignments, setPalletAssignments] = useState({});

    const getBulkOrderDetails = async (searchValue) => {

        props.setLoading(true);

        try {
            const search = { order_number: searchValue };
            const palletInfoResponse = await orderHelpers.getBulkOrderPalletInfo(props.company, props.token, search);
            const detailResponse = await orderHelpers.getBulkOrderPalletDetails(props.company, props.token, searchValue);

            if (palletInfoResponse?.isAxiosError || !detailResponse?.success) {
                props.toast?.error( "Encountered an error while retrieving order details.");
                return;
            }

            setOrderSummary(palletInfoResponse.order_info || []);
            const details = detailResponse.data?.order_info || [];
            console.log("details", details);
            setOrderDetails(details);
            const existingAssignments = {};
            details.forEach(row => {
                if (row.pallet_number) {
                    existingAssignments[row.order_id] =
                        row.pallet_number;
                }
            });
            console.log("eist", existingAssignments);
            setPalletAssignments(existingAssignments);

        }
        catch (err) {
            console.log(err);
            props.toast?.error( "Encountered an error while retrieving order details." );

        }
        finally {
            props.setLoading(false);
        }
    };

    const updatePalletAssignments = async () => {
        const assignments = orderDetails
            .filter((row) => {
                const currentValue =
                    palletAssignments[row.order_id] ?? "";

                const originalValue =
                    row.pallet_number ?? "";

                return (
                    String(currentValue).trim() !== "" &&
                    String(currentValue) !== String(originalValue)
                );
            })
            .map((row) => ({
                order_id: row.order_id,
                box_id: row.box_id,
                pallet_number: Number(
                    palletAssignments[row.order_id]
                )
            }));

        if (assignments.length === 0) {
            props.toast?.error(
                "No pallet assignment changes to update."
            );
            return;
        }

        const po_number = orderDetails[0].internal_po_number;

        props.setLoading(true);

        try {
            const response =
                await orderHelpers.updatePalletAssignments(
                    props.company,
                    props.token,
                    po_number,
                    assignments
                );

            if (response?.success) {
                const updatedAssignments = new Map(
                    assignments.map((assignment) => [
                        assignment.order_id,
                        assignment.pallet_number
                    ])
                );

                setOrderDetails((currentRows) =>
                    currentRows.map((row) =>
                        updatedAssignments.has(row.order_id)
                            ? {
                                ...row,
                                pallet_number:
                                    updatedAssignments.get(
                                        row.order_id
                                    )
                            }
                            : row
                    )
                );

                props.toast?.success(
                    "Pallet assignments updated."
                );
            } else {
                props.toast?.error(
                    "Unable to update pallet assignments."
                );
            }
        } catch (err) {
            console.error(err);

            props.toast?.error(
                err.response?.data?.message ||
                "Unable to update pallet assignments."
            );
        } finally {
            props.setLoading(false);
        }
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            className={props.isMobile ? "mobile-top" : "desktop-top"}
        >
            <Box
                className={props.isMobile ? "mobile-box" : "desktop-box"}
                sx={{ paddingLeft: 3 }}
            >
                <h1>Walmart Pallet Allocation</h1>

                <WalmartPalletAllocationForm
                    getBulkOrderDetails={getBulkOrderDetails}
                    isLoading={props.isLoading}
                    isMobile={props.isMobile}
                />

                {orderSummary.length > 0 ? (
                    <WalmartPalletAllocationSummaryTable
                        orders={orderSummary}
                        isMobile={props.isMobile}
                    />
                ) : null}

                {orderDetails.length > 0 ? (
                    <>
                        <WalmartPalletAllocationTable
                            orders={orderDetails}
                            isMobile={props.isMobile}
                            palletAssignments={palletAssignments}
                            setPalletAssignments={setPalletAssignments}
                            palletCount={orderSummary[0]?.pallet_count || 0}
                        />

                        <Button
                            sx={{ mt: '20px' }}
                            variant="contained"
                            color="success"
                            disabled={props.isLoading}
                            onClick={updatePalletAssignments}
                        >
                            Update Pallet Assignments
                        </Button>
                    </>
                ) : null}

            </Box>
        </Box>
    );
}

export default WalmartPalletAllocation;